import React from "react";
import { Container, Row, Col, Card, CardHeader, Button } from '@/Components/ui';;
import BreadCrumb from "../../../Components/Common/BreadCrumb";

import { API_USERS_CRM, getDataFromUrl, API, BACKEND_HOST } from "../../../api";
import ServerPaginatedTable from "../../../Components/Common/ServerPaginatedTable";
import { Link, useNavigate } from "react-router-dom";
import { SUBDOMAIN } from "../../../assets/meta/meta";
import UserSendModal from "./send-modal";

import toast, { Toaster } from 'react-hot-toast';

const UserList = () => {

  const [sendModal, setSendModal] = React.useState(false);
  // const [modalFocus, setModalFocus] = React.useState({});
  const [selectedUsers, setSelectedUsers] = React.useState([]);


  const [data, setData] = React.useState([]);
  const [previous, setPrevious] = React.useState("");
  const [next, setNext] = React.useState("");
  const [count, setCount] = React.useState("");

  const onRequestData = (_url) => {
    getDataFromUrl(_url)
      .then((data) => {
        setData(data.results);
        setPrevious(data.previous);
        setNext(data.next);
        setCount(data.count);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  React.useEffect(() => {
    if (!previous && !next) {
      getDataFromUrl(API_USERS_CRM)
        .then((data) => {
          // console.log(data);
          setData(data.results);
          setPrevious(data.previous);
          setNext(data.next);
          setCount(data.count);
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }, []);


  const columns = React.useMemo(
    () => [
      {
        Header: <input type="checkbox"
          id="checkBoxAll"
          className="form-check-input"
          onClick={() => checkedAll()} />,
        Cell: (cellProps) => {
          return <input type="checkbox"
            className="customerCheckBox form-check-input"
            id={`checkBox${cellProps.row.original.id}`}
            value={cellProps.row.original.id}
            onClick={checkedOne} />;
        },
        id: "#",
      },
      {
        Header: "번호",
        accessor: "row_number",
        id: "row_number",
      },
      // {
      //   Header: 'ID',
      //   accessor: 'id',
      //   id: 'id',
      // },
      {
        Header: "이름",
        accessor: "이름",
        id: "username",
        Cell: (cellProps) => {
          return (
            <Link to={`/user/${cellProps.row.original.id}`} className="link">
              <span>{cellProps.row.original["이름"]}</span>
            </Link>
          );
          // return <a href={`/user/${cellProps.row.original.id}`} className="stretched-link"><span>{cellProps.row.original['이름']}</span></a>
        },
      },
      // {
      //   Header: '이메일',
      //   accessor: '이메일',
      //   id: 'email',
      // },
      {
        Header: "전화번호",
        accessor: "전화번호",
        id: "phone_num",
        Cell: (cellProps) => {
          return (
            <Link to={`/user/${cellProps.row.original.id}`} className="link">
              <span>{cellProps.row.original["전화번호"]}</span>
            </Link>
          );
        },
      },
      {
        Header: "가입일",
        accessor: "가입일",
        id: "date_joined",
      },
      // {
      //   Header: '교환권',
      //   accessor: '교환권',
      //   id: 'uservoucher',
      // },
      {
        Header: "Action",
        accessor: "action",
        id: "action",
        Cell: (cellProps) => {
          return (
            <div className="d-flex gap-3">
              <Button
                onClick={() => {
                  pressOneUserSend(cellProps.row.original.id);
                }}
                color="soft-primary" size="sm" className="edit-item-btn">
                <span className="align-middle">쿠폰 보내기</span>
              </Button>
            </div>
          );
        }
      }
    ],
    []
  );


  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".customerCheckBox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }

    const selected = [];
    ele.forEach((ele) => {
      if (ele.checked) {
        selected.push(ele.value);
      }
    });
    setSelectedUsers(selected);
    console.log("selectedUsers", selected);
  };

  const checkedOne = (e) => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".customerCheckBox");

    if (e.target.checked) {
      let allChecked = true;
      ele.forEach((ele) => {
        if (!ele.checked) {
          allChecked = false;
        }
      });
      checkall.checked = allChecked;
    } else {
      checkall.checked = false;
    }

    const selected = [];
    ele.forEach((ele) => {
      if (ele.checked) {
        selected.push(ele.value);
      }
    });
    setSelectedUsers(selected);
    console.log("selectedUsers", selected);
  }

  const pressOneUserSend = (cellId) => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".customerCheckBox");
    checkall.checked = false;
    ele.forEach((ele) => {
      ele.checked = false;
      if (ele.value === cellId) {
        ele.checked = true;
      }
    });
    setSelectedUsers([cellId]);
    setSendModal(true);
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="사용자관리" pageTitle="사용자" />
          <Row>
            <Col lg={12}>
              <Card id="customerList">
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-sm">
                      <div>
                        <h5 className="card-title mb-0">사용자 목록</h5>
                      </div>
                    </div>
                    <div className="col-sm-auto">
                      <div>

                        <Button
                          onClick={() => {
                            setSendModal(true);
                          }}
                          color="soft-secondary" className="me-1">
                          사용자에게 쿠폰 보내기
                        </Button>

                      </div>
                    </div>
                  </Row>
                </CardHeader>

                <div className="card-body pt-0">
                  <div>
                    <React.Fragment>
                      <ServerPaginatedTable url={API_USERS_CRM} columns={columns} data={data} previous={previous} next={next} count={count} onRequestData={onRequestData} categories={[]} />
                    </React.Fragment>
                  </div>
                </div>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <UserSendModal
        visible={sendModal}
        setVisible={setSendModal}
        userList={selectedUsers}

        onSendSuccess={(message) => {
          toast.success(message);
          setSendModal(false);
        }}

        onSendError={(message) => {
          toast.error(message);
          setSendModal(false);
        }}
      />


      <Toaster position="top-center" />

    </React.Fragment>
  );
};

export default UserList;
